import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Auth, auth } from "../lib/api.js";
import { TextField, Button, Banner, isValidEmail, COLORS as C } from "../components/UI.jsx";

export default function Login() {
  const navigate = useNavigate();
  if (auth.loggedIn()) { navigate("/dashboard", { replace: true }); return null; }

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);

  const submit = async () => {
    setError(null);
    if (!email.trim()) { setError("Enter your email."); return; }
    if (!isValidEmail(email)) { setError("Enter a valid email address."); return; }
    if (!password) { setError("Enter your password."); return; }
    setBusy(true);
    try {
      await Auth.login(email.trim().toLowerCase(), password);
      navigate("/dashboard");
    } catch (err) {
      setError(err.message || "Sign in failed. Please check your email and password.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div style={{
      minHeight: "100vh", background: C.cream,
      display: "flex", alignItems: "center", justifyContent: "center",
      padding: 20, fontFamily: "-apple-system, system-ui, Inter, sans-serif",
    }}>
      <div style={{ width: "100%", maxWidth: 420 }}>
        <Link to="/" style={{ textDecoration: "none", display: "inline-flex", alignItems: "center", gap: 10, marginBottom: 28 }}>
          <div style={{
            width: 32, height: 32, background: C.red, borderRadius: 8,
            display: "flex", alignItems: "center", justifyContent: "center",
            color: C.white, fontWeight: 800, fontSize: 16,
          }}>S</div>
          <div style={{ fontSize: 19, fontWeight: 800, color: C.navy }}>Shiftswift</div>
        </Link>

        <div style={{
          background: C.white, borderRadius: 14, padding: 32,
          border: `1px solid ${C.line}`,
          boxShadow: "0 8px 24px rgba(0,0,0,0.04)",
        }}>
          <h1 style={{ fontSize: 24, fontWeight: 800, color: C.navy, margin: 0 }}>
            Welcome back
          </h1>
          <p style={{ fontSize: 14, color: C.text3, marginTop: 8, marginBottom: 24 }}>
            Sign in to continue.
          </p>

          {error && <Banner kind="error" onDismiss={() => setError(null)}>{error}</Banner>}

          <TextField
            label="Email" type="email" value={email} onChange={setEmail}
            placeholder="priya@business.com" autoFocus required
            autoComplete="email"
          />
          <TextField
            label="Password" type="password" value={password} onChange={setPassword}
            placeholder="Your password" required
            autoComplete="current-password"
            onEnter={submit}
          />

          <div style={{ textAlign: "right", marginTop: -8, marginBottom: 16 }}>
            <Link to="/forgot-password" style={{ fontSize: 12, color: C.red, fontWeight: 600, textDecoration: "none" }}>
              Forgot password?
            </Link>
          </div>

          <Button onClick={submit} busy={busy}>
            {busy ? "Signing in…" : "Sign in"}
          </Button>

          <div style={{
            marginTop: 24, paddingTop: 20, borderTop: `1px solid ${C.line}`,
            fontSize: 14, color: C.text2, textAlign: "center",
          }}>
            New to Shiftswift?{" "}
            <Link to="/join" style={{ color: C.red, fontWeight: 700, textDecoration: "none" }}>
              Open an account
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
